import { getSangjoQuotationRequestExists } from "@/apis/sangjoQuotation";
import { isLoggedInState } from "@/atoms/accountState";
import { matchRequestResDataState } from "@/atoms/match/matchRequestResDataState";
import { useSangjoQuotationRequestExistModal } from "@/hooks/useSangjoQuotationRequestExistModal";
import { customEvent, VStack } from "goi_common";
import { useRouter } from "next/router";
import { useEffect, useLayoutEffect } from "react";
import { useRecoilValue } from "recoil";
// import RequestQuestionUniqueStep from "./components/RequestQuestionUniqueStep";
import { ParlorDetailProps } from "@/types/parlor";
import ParlorRequestQuestionStepByStep from "./components/ParlorRequestQuestionStepByStep";
// import { useCustomVariation } from "@/hooks/useCustomVariation";
// import useRouterChangeLoad from "./hooks/useRouterChangeLoad";

export default function ParlorRequestContainer({ parlor }: { parlor: ParlorDetailProps }) {
  // const variation = useCustomVariation(120);
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const router = useRouter();
  const responseData = useRecoilValue<any>(matchRequestResDataState);

  const { onOpenRequestExistModal } = useSangjoQuotationRequestExistModal();

  useLayoutEffect(() => {
    customEvent({
      newGtm: {
        path: "parlor_match_request",
        trigger_and_target: "uv_parlor_match_request",
      },
    });
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      getSangjoQuotationRequestExists().then((res) => {
        if (res.request_exists) {
          onOpenRequestExistModal(res.first_quotation_id);
        } else {
          if (responseData.id && responseData.funeral_sido && responseData.funeral_sigungu) {
            router.push(
              `/match/request-complete?id=${responseData.id}&sido=${responseData.funeral_sido}&sigungu=${responseData.funeral_sigungu}`,
            );
            return;
          }
        }
      });
    }
  }, [isLoggedIn]);

  return (
    <VStack alignItems="center">
      <VStack id="wrapper" width="100%" maxWidth="480px">
        {/* {variation === "A" && <RequestQuestionUniqueStep parlor={parlor} />} */}
        <ParlorRequestQuestionStepByStep parlor={parlor} />
      </VStack>
    </VStack>
  );
}
